module.exports = __webpack_public_path__ + "static/media/  (88).f7569217.jpg";